<template>
  <div>
    <MainMenu />
    <v-main class="py-0">
      <v-img 
        min-height="250" 
        max-height="250" 
        src="@/assets/AbountUsImages/sala_estar.jpg"
      ></v-img>
      <v-container>
        <v-layout row wrap v-if="$vuetify.breakpoint.mdAndUp">
          <v-col cols="7" >
            <h1 class="py-3">Quem Somos</h1>
            <p class="font-weight-light"> {{ abountUsText }} </p>
          </v-col>
          <v-img 
            max-height="476" 
            max-width="410" 
            src="@/assets/AbountUsImages/trabalho_computador.png"
          ></v-img>
        </v-layout>

        <v-layout row wrap v-if="$vuetify.breakpoint.smAndDown">
          <v-col cols="11" >
            <h1 class="py-3">Quem Somos</h1>
            <p class="font-weight-light"> {{ abountUsText }} </p>
          </v-col>
        </v-layout>
      </v-container>
    </v-main>
    <v-spacer class="pt-10"></v-spacer>
    <BottomBar />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import MainMenu from '@/components/Global/MainMenu.vue'
import BottomBar from '@/components/Global/BottomBar.vue'

export default {
  name: 'AbountUsScreen',

  components: {
    MainMenu,
    BottomBar,
  },

  data: () => ({
    abountUsText: "Precisando de uma solução ou querendo investir no mercado imobiliário, conte com a máxima transparência e atenção de corretor especializado. Somos especializados na compra, venda e aluguel de imóveis, prestamos toda assessoria necessária à realização de uma transação segura e tranquila, com acompanhamento jurídico e operacional de qualidade. Reconhecidos pela ética profissional e transparência no mercado imobiliário, oferecemos a nossos clientes um atendimento personalizado, resultando em segurança e satisfação a todos os negócios realizados. Possuímos profissionais capacitados e diferenciados para uma total eficiência e garantia nas intermediações imobiliárias. Entre em contato, teremos o prazer em ajudá-lo a realizar o sonho de adquirir a casa própria."
  }),

  mounted() {
    this.cleanBuyMenuId()
    this.cleanRentMenuId()
  },

  computed: {

  },

  watch: {

  },

  methods: {
    ...mapActions({
      cleanBuyMenuId: 'Immobile/cleanBuyMenuId',
      cleanRentMenuId: 'Immobile/cleanRentMenuId',
    }),

    ...mapGetters({

    }),
  },
};
</script>